import { t } from 'i18next';
import { useEffect, useState } from 'react';

import { AiBuilderChatMessage } from './ai-builder-utils';
import { ChatMessage } from './chat-message';

interface LoadingMessageProps {
  message?: string;
}

const ANIMATION_INTERVAL = 500;
const MAX_DOTS = 3;

const LoadingMessage = ({
  message = t('Thinking...'),
}: LoadingMessageProps) => {
  const baseMessage = message.replace(/\.+$/, '');
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => '.'.repeat((prev.length % MAX_DOTS) + 1));
    }, ANIMATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  const displayedMessage: AiBuilderChatMessage = {
    content: `${baseMessage}${dots}`,
    userType: 'bot',
  };

  return (
    <ChatMessage
      message={displayedMessage}
      isLastMessage={false}
      muted={true}
      thinking={true}
    />
  );
};

LoadingMessage.displayName = 'LoadingMessage';

export { LoadingMessage };
